const API_BASE = process.env.VUE_APP_API_BASE;
const API_ESTADISTICAS = `${API_BASE}/ajax/estadisticas.php`;

export default {
  namespaced: true,

  state: {
    data: null,
    loading: false,
    error: null
  },

  getters: {
    getEstadisticas: (state) => state.data,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  mutations: {
    SET_ESTADISTICAS(state, payload) {
      state.data = payload
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },

  actions: {
    async fetchEstadisticas({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(API_ESTADISTICAS)
        const data = await response.json()

        if (data.success) {
          commit("SET_ESTADISTICAS", data.estadisticas)
        } else {
          commit("SET_ERROR", data.error || "Error al obtener estadísticas")
        }
      } catch (error) {
        console.error("Error cargando estadísticas:", error)
        commit("SET_ERROR", "Error de conexión al cargar estadísticas")
      } finally {
        commit("SET_LOADING", false)
      }
    }
  }
}